import { render, staticRenderFns } from "./wxBasics.vue?vue&type=template&id=115327ba&scoped=true&"
import script from "./wxBasics.vue?vue&type=script&lang=js&"
export * from "./wxBasics.vue?vue&type=script&lang=js&"
import style0 from "./wxBasics.vue?vue&type=style&index=0&id=115327ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115327ba",
  null
  
)

export default component.exports